module.exports = __webpack_public_path__ + "media/images/pokerroom/titan/description-pict-3f5e648a4e3965d38400991d41f68f4c.jpg";